import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Documento } from 'src/app/models/documento';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ArchivoCargaService } from 'src/app/services/notificaciones/archivoCarga.service';
import { DocSolicitudService } from 'src/app/services/perfilamiento/doc-solicitud.service';
import { Utils } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-file-upload-physical-docs',
  templateUrl: './file-upload-physical-docs.component.html',
  styleUrls: ['./file-upload-physical-docs.component.scss']
})
export class FileUploadPhysicalDocsComponent {

  @Input() rules: string[] = []; // reglas para carga de archivos
  @Input() title: string = ""; // titulo de la tarjeta
  @Input() subtitle: string = ""; // subtitulo de la tarjeta
  @Input() contract: boolean = false; // titulo de la tarjeta
  @Input() secuencia: number = 0; // secuencia para aws
  @Input() idFolder: number = 0; // idFolder aws
  @Input() identificacion: string = ""; // Identificacion fileserver
  @Input() nombreArchivoFinal: string = ""; // nombre del comprimido
  @Input() solicitarNombreArchivo: boolean = false; // solicitar nombres de cada documento y no comprimirlos en un pdf

  @Output() finalizaCarga = new EventEmitter<string>();

  constructor(
    public deviceService: DeviceDetectorService,
    public data: DataService,
    private http: HttpClient,
    private readonly datepipe: DatePipe,
    private readonly serviceCarga: ArchivoCargaService,
    private readonly serviceDoc: DocSolicitudService,
    private dialogService: DialogService,
    private router: Router
  ) {
  }

  private readonly utils = new Utils();
  public masAdicionals: Documento[] = [];
  public loading = false;

  ngOnInit(): void {
    if (this.contract) {
      this.docsContrato();
    }
  }

  get nombresValidos(): boolean {
    let valido: boolean = true
    this.masAdicionals.forEach(doc => {
      if (doc.nombre === '') {
        valido = false
      }
    });
    return valido
  }

  public docsContrato() {
    this.http
      .post(`${environment.ApiConecta}generacion/documentos/ADO`, {
        numeroCarpeta: this.data.numeroCarpeta,
      })
      .subscribe(
        (http: any) => {
          this.http = http;
          this.data.contrato_url = http.contrato_url;
          this.data.pagare_url = http.pagare_url;
          let splited = http.contrato_url.split('/');
          this.data.nombre_contrato = splited[splited.length - 1].split('?')[0];
          let splited2 = http.pagare_url.split('/');
          this.data.nombre_pagare = splited2[splited.length - 1].split('?')[0];
        },
        (error) => {
          this.dialogService.openDialog(
            'Opps',
            'Los documentos no fueron cargados correctamente, por favor intentanlo más tarde',
            false
          )
        }
      );
  }
  public async subirArchivos() {
    let document: Documento[] = this.masAdicionals;
    if (document.length === 0) return;
    this.loading = true;
    let timestamp: string = this.datepipe.transform(new Date(), 'yyyyMMddHHmmss')!;
    let documentosParaSubir: Documento[] = [];

    if (!this.solicitarNombreArchivo) {
      let name = `${this.nombreArchivoFinal}-${timestamp}.pdf`;
      const pdfBytes = await this.utils.appendPDF(document.map((doc) => doc.archivo));
      const pdfFile = new File([new Blob([pdfBytes as ArrayBuffer])], name, {
        type: 'application/pdf',
        lastModified: new Date().getTime(),
      });
      documentosParaSubir.push({
        status: true,
        nombre: name,
        archivo: pdfFile,
        secuencia: this.secuencia,
      });
    } else {
      documentosParaSubir = [...document];
    }

    try {
      const promesas = documentosParaSubir.map(async (documentoParaSubir) => {
        const respuesta = await this.serviceCarga.cargandoArchivo(
          this.data.numeroCarpeta,
          this.identificacion,
          this.solicitarNombreArchivo ? `PORTAL-${documentoParaSubir.nombre.split('.')[0]}-${timestamp}.pdf` : documentoParaSubir.nombre
        ).toPromise();

        const form = new FormData();
        Object.keys(respuesta.fields).forEach((key) =>
          form.append(key, respuesta.fields[key])
        );
        form.append('Content-Type', 'application/pdf');
        form.append('file', documentoParaSubir.archivo);

        const res = await fetch(respuesta.url, {
          method: 'POST',
          body: form,
        });

        if (!res.ok) {
          throw new Error('Error al subir a S3');
        }

        await this.serviceDoc.uploadAwsRoute(
          this.data.numeroCarpeta,
          respuesta.fields.key,
          documentoParaSubir.secuencia,
          this.idFolder
        ).toPromise();
      });

      await Promise.all(promesas);

      this.finalizaCarga.emit();

    } catch (error) {
      this.loading = false;
      this.dialogService.openDialog(
        'Oops',
        'Error al cargar uno o más archivos. Intenta nuevamente, por favor.',
        false
      );
    } finally {
      this.loading = false;
    }
  }
  
  goHome(){
    this.router.navigate(['/home']);
  }
}
